import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import { useContext } from "react"
import App from "~/contexts/App"
import useStyles from "./styles"

const DeleteImageDialog = () => {
  const classes = useStyles()

  const { dialogs, closeDialog } = useContext(App)
  const thisDialog = dialogs?.["deleteImageDialog"] || {}
  const { open = false, data = {} } = thisDialog

  const setLoading = thisDialog?.data?.setLoading
  const type = thisDialog?.data?.type
  const onUpload = thisDialog?.data?.onUpload

  const handleClose = () => {
    closeDialog("deleteImageDialog", false)
  }

  const handleDelete = () => {
    closeDialog("deleteImageDialog", false)
    setLoading(true)
    onUpload(null, setLoading, type)
    setLoading(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h3" style={{ fontWeight: 700, flexShrink: 0 }}>
          Delete Image
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography>Woah There!</Typography>
        <Typography>{"Are you sure you want to delete this image?"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button disableElevation onClick={handleClose} type="button">
          Cancel
        </Button>
        <Button
          disableElevation
          style={{ backgroundColor: "red", color: "white" }}
          variant="contained"
          onClick={handleDelete}
          type="button"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteImageDialog
